"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.RedirectionScreenType=void 0;var e;(function(r){r.Otc="OTC"})(e||(exports.RedirectionScreenType=e={}));
//# sourceMappingURL=RedirectionScreenType.js.map
